import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";
import { setStatusFail } from "../../redux/statusFail/statusFailSlice";

const initialState = {
  billing: {},
  billings: [],
  totalPages: 0,
  error: null,
  isLoading: false,
  practitioners: null,
  serviceData: null,
};
const ADMIN_URL = process.env.REACT_APP_ADMIN_URL;


export const getBillingById = createAsyncThunk(
  "billing/getBillingById",
  async (billId, { rejectWithValue,dispatch }) => {
    try {
      const response = await axios.get(`${ADMIN_URL}/billing/${billId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("Token")}`,
        },
      });
  
      return response.data.data; 
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue(error.response?.data?.error?.message || "Something went wrong");
    }
  }
);


export const getAllBillings = createAsyncThunk(
  "billing/getAllBillings",
  async (
    { currentPage, itemsPerPage, sortBy, order, locationId, billType },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const response = await axios.get(`${ADMIN_URL}/billing`, {
        params: {
          page: currentPage,
          limit: itemsPerPage,
          sortBy,
          order,
          ...(billType ? { billType } : {}),
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("Token")}`,
          tenantid: Cookies.get("TenantId"),
          ...(locationId ? { "location-id": locationId } : {}),
        },
      });
      return response.data.data;
    } catch (error) {
      if (error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED") {
        const route = "/status-failed";
        await dispatch(
          setStatusFail({
            tenants: error.response.data.tenants,
            navigate: route,
          })
        );
      }
      return rejectWithValue(
        error.response?.data?.error?.message || "Something went wrong"
      );
    }
  }
);

const billingSlice = createSlice({
  name: "billing",
  initialState,
  reducers: {
    clearBillingError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
     .addCase(getBillingById.pending, (state) => {
        state.billingStatus = "loading";
        state.error = null;
      })
      .addCase(getBillingById.fulfilled, (state, action) => {
        state.billingStatus = "succeeded";
        state.billing = action.payload; 
      })
      .addCase(getBillingById.rejected, (state, action) => {
        state.billingStatus = "failed";
        state.error = action.payload; 
      })
      .addCase(getAllBillings.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAllBillings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.billings = action.payload.data;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(getAllBillings.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearBillingError } = billingSlice.actions;
export default billingSlice.reducer;
